import RequestHandler from "./RequestHandler";

function ModelVersionsAPI() {
    const baseModelVersionsAPI = "model-parameter-versions";

    async function getModelVersions(
        modelId,
        itemsPerPage,
        filters = {},
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${baseModelVersionsAPI}/list/${modelId}?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getVersionResultsFile(id) {
        try {
            const result = await RequestHandler.get(
                `${baseModelVersionsAPI}/signed-url/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getVersionById(id) {
        try {
            const result = await RequestHandler.get(
                `${baseModelVersionsAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateVersion(updatedVersion) {
        try {
            const result = await RequestHandler.put(
                `${baseModelVersionsAPI}`,
                updatedVersion
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function activateVersion(version) {
        try {
            const result = await RequestHandler.put(
                `${baseModelVersionsAPI}/activate`,
                version
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteVersion(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseModelVersionsAPI}/${id}`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function updateBiasCorrection(body) {
        try {
            const result = await RequestHandler.put(
                `${baseModelVersionsAPI}/bias-corrections`,
                body
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getReview(modelParameterVersionIds) {
        try {
            const result = await RequestHandler.post(
                `${baseModelVersionsAPI}/versions-details`,
                modelParameterVersionIds
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function exportVersionDetails(payload) {
        try {
            const result = await RequestHandler.post(
                `${baseModelVersionsAPI}/export/version-details/csv`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function importVersionDetails() {
        try {
            const result = await RequestHandler.get(
                `${baseModelVersionsAPI}/import/version-details/signed-url`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function uploadVersions(payload) {
        try {
            const result = await RequestHandler.post(
                `${baseModelVersionsAPI}/upload-versions`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function checkVersionName(modelParameterId, versionName, versionId) {
        try {
            const result = await RequestHandler.get(
                `${baseModelVersionsAPI}/check-version-name/${modelParameterId}?version=${versionName}&versionId=${versionId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getModelVersions,
        getVersionResultsFile,
        activateVersion,
        deleteVersion,
        getVersionById,
        updateVersion,
        updateBiasCorrection,
        getReview,
        exportVersionDetails,
        importVersionDetails,
        uploadVersions,
        checkVersionName,
    };
}

export default ModelVersionsAPI();
